import { Link, TableCell, Typography } from "@mui/material";
import {
  createSearchRequestProvider,
  getActiveFiltersCount,
  preprocessSearchRequest,
  withoutBaseTableModel,
} from "~/components/Table";
import {
  commonResourceColumns,
  selectCountableListResponse,
} from "~/domain/common";
import type { APIKey, LqsColumn } from "~/lqs";
import { LqsResourceTable, useApiKeys } from "~/lqs";
import {
  DataStoreLink,
  makeApiKeyLocation,
  makeNewApiKeyLocation,
} from "~/paths";
import { listApiKeysSchema } from "../schemas";

const columns: ReadonlyArray<LqsColumn<APIKey>> = [
  {
    header: "Name",
    sortKey: "name",
    renderCell(apiKey) {
      return (
        <TableCell>
          {apiKey.name}
          <Link
            component={DataStoreLink}
            to={makeApiKeyLocation({ apiKeyId: apiKey.id })}
          >
            <Typography variant="body2">{apiKey.id}</Typography>
          </Link>
        </TableCell>
      );
    },
  },
  {
    accessor: "userId",
    dataType: "foreign-key",
    resourceType: "user",
  },
  {
    accessor: "disabled",
    dataType: "boolean",
    isSortable: true,
    defaultHidden: true,
  },
  ...commonResourceColumns,
];

export const [useApiKeySearchRequest, ApiKeySearchRequestProvider] =
  createSearchRequestProvider({
    columns,
    filterSchema: listApiKeysSchema,
  });

export function ApiKeyTable() {
  const [request, setRequest] = useApiKeySearchRequest();

  const searchQuery = useApiKeys(preprocessSearchRequest(request), {
    keepPreviousData: true,
    cacheTime: 0,
    select: selectCountableListResponse,
  });

  const filterValues = withoutBaseTableModel(request);

  return (
    <LqsResourceTable
      resourceName="API Key"
      resourceCreateLocation={makeNewApiKeyLocation()}
      getRowKey={(apiKey) => apiKey.id}
      columns={columns}
      searchQuery={searchQuery}
      tableModel={request}
      onTableModelChange={setRequest}
      activeFilterCount={getActiveFiltersCount(filterValues)}
    />
  );
}
